import {atom} from "recoil";

const authLocationState = atom({
    key: "AUTH_LOCATION_STATE",
    default: "/"
})

export default authLocationState;